// extracted by mini-css-extract-plugin
export var dataCell = "_m2-2";
export var dataRow = "_m2-0";
export var headerRow = "_m2-1";